/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lr-trans': {
    width: 8,
    height: 9,
    viewBox: '0 0 8 9',
    data: '<path pid="0" d="M7.875 3.375V2.25H6.468L6.748 0H5.625l-.281 2.25h-2.25L3.374 0H2.25l-.28 2.25H0v1.125h1.828l-.281 2.25H0V6.75h1.406L1.125 9H2.25l.281-2.25h2.25L4.5 9h1.126l.281-2.25h1.969V5.625H6.047l.28-2.25h1.548zm-2.953 2.25h-2.25l.28-2.25h2.25l-.28 2.25z" _fill="#376F99" fill-rule="nonzero"/>'
  }
})
